import { Component, HostListener, ViewChild } from '@angular/core'
import { MatGridListModule } from '@angular/material/grid-list'
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { LineupService } from './services/lineup.service'
import { LineupFieldComponent } from './components/field/field.component'
import { SigningsComponent } from './components/signings/signings.component'
import { NewsService } from '../news/services/news.service'
import { Rumour } from '../../core/models/rumour.model'
import { AuthService } from '../../core/services/auth.service'
import { Carousel, CarouselModule } from 'primeng/carousel'
import { MatDividerModule } from '@angular/material/divider'
import { RumoresCard } from '../news/components/rumores/components/rumores-card/rumores-card.component'
import { MatDialog } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { lineups } from '../../core/models/positions.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatInputModule } from '@angular/material/input'
import { Title } from '@angular/platform-browser'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
    selector: 'lineup-component',
    templateUrl: 'lineup.component.html',
    standalone: true,
    imports: [
      MatGridListModule, 
      CommonModule,
      RouterModule, 
      ReactiveFormsModule, 
      LineupFieldComponent, 
      SigningsComponent,
      MatInputModule,
      MatSlideToggleModule,
      MatDividerModule,
      MatButtonModule,
      MatIconModule,
      MatSelectModule,
      MatFormFieldModule,
      CarouselModule,
      MatTooltipModule,
      FormsModule,
      RumoresCard
    ],
    styleUrl: './lineup.component.css'
})
export class LineupComponent{
  @ViewChild('carousel', { static: false }) carousel!: Carousel

  get numVisible(): number {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return 3
    }
    return window.innerWidth > 1198 ? 3 : 2;
  }

  rumores: Rumour[] = []
  formations: string[] = []

  constructor(
    public service: LineupService,
    public newsService: NewsService,
    public auth: AuthService,
    public dialog: MatDialog,
    private title: Title,
  ){
    this.formations = Object.keys(lineups)
    const form = this.service.getForm('for') as FormGroup
    form.get('name')?.setValue('Atleti 25/26')
  }

  ngAfterViewInit() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return
    }
    this.title.setTitle('Atlético Stats - Lineup')

    this.newsService.rumourFilters.get('type')?.setValue("FICHAJE")
    this.newsService.fetchFilteredRumours()
    .subscribe(data =>{
      this.rumores = data as Rumour[]
      
      const probabilityOrder = { "HIGH": 3, "MEDIUM": 2, "LOW": 1, "OFFICIAL": 0, "NULL": 0 }
      this.rumores.sort((a, b) => {
        const probA = probabilityOrder[a.probability] || 0
        const probB = probabilityOrder[b.probability] || 0
        return probB - probA
      })

    })
  }
  
  getTwitterShareUrl(): string {
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent('Esta es mi pajiplantilla del Atleti. Haz la tuya en: atleticostats.com/lineup @atletico_stats_')}`
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    const isOverCarousel = (event.target as HTMLElement).closest('.rumores-carousel')

    if (isOverCarousel) {
      event.preventDefault()

      if (event.deltaY > 0) {
        this.carousel.navForward(event)
      } else {
        this.carousel.navBackward(event)
      }
    }
  }
}